import { Component, OnInit, Input, ViewChild, ComponentRef } from '@angular/core';
import { AppGlobal } from '../../../app/core/state/app-global';
import { GlobalConstants } from '../../common/constants/global.constant';
import { User } from '../account/login/_models/user.model';
import { CreateCustomInstallationPackageComponent } from './create-custom-installation-package/create-custom-installation-package.component';
import { IposHelpAddingCustomContentToIposComponent } from './ipos-help-adding-custom-content-to-ipos/ipos-help-adding-custom-content-to-ipos.component';
import { IposHelpAssetLibraryComponent } from './ipos-help-asset-library/ipos-help-asset-library.component';
import { IposHelpDeviceComponent } from './ipos-help-device/ipos-help-device.component';
import { IposHelpFaqComponent } from './ipos-help-faq/ipos-help-faq.component';
import { IposHelpOdaComponent } from './ipos-help-oda/ipos-help-oda.component';
import { IposHelpInstallingChromebookComponent } from './ipos-help-installing-chromebook/ipos-help-installing-chromebook.component';
import { IposHelpIdleAssistantComponent } from './ipos-help-idle-assistant/ipos-help-idle-assistant.component';
import { IposHelpUninstallingChromebookComponent } from './ipos-help-uninstalling-chromebook/ipos-help-uninstalling-chromebook.component';
import { IposHelpPartnerContentComponent } from './ipos-help-partner-content/ipos-help-partner-content.component';
import { IposHelpPartnerPortalComponent } from './ipos-help-partner-portal/ipos-help-partner-portal.component';
import { CommonService } from '../../common/services/common.service';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { Subject } from 'rxjs/internal/Subject';
import { IposHelpUninstallationPackageComponent } from './ipos-help-uninstallation-package/ipos-help-uninstallation-package.component';
import { IposHelpInstallationPackageComponent } from './ipos-help-installation-package/ipos-help-installation-package.component';
import { IposHelpSkuComponent } from './ipos-help-sku/ipos-help-sku.component';

@Component({
  selector: 'iposcen-ipos-help',
  templateUrl: './ipos-help.component.html',
  styleUrls: ['./ipos-help.component.scss']
})
export class IposHelpComponent implements OnInit {
  isUserAuthor: boolean = false;
  assetToHelp;
  sideNav: string;
  isExpanded = false;
  selectedNav: string;
  iscustomContentToIposExpanded: boolean = false;
  isAssetLibraryExpanded: boolean = false;
  isDeviceExpanded = false;
  isCreateCustomInstallationExpanded: boolean = false;
  isInstallationProcessExpanded: boolean = false;
  isFaqExpaned: boolean = false;
  isOdaExpaned: boolean = false;
  isChromebookExpanded: boolean = false;
  isUninstallExpanded: boolean = false;
  isSkuExpanded: boolean = false;
  chromeSideNav: string;
  loginUserRole = sessionStorage.getItem('userRole');
  @ViewChild(IposHelpPartnerPortalComponent) partnercomp: IposHelpPartnerPortalComponent;
  @ViewChild(IposHelpAssetLibraryComponent) assetscomp: IposHelpAssetLibraryComponent;
  @ViewChild(IposHelpFaqComponent) faqcomp: IposHelpFaqComponent;
  @ViewChild(IposHelpOdaComponent) odacomp: IposHelpOdaComponent;
  @ViewChild(CreateCustomInstallationPackageComponent) installcomp: CreateCustomInstallationPackageComponent;
  @ViewChild(IposHelpAddingCustomContentToIposComponent) addcomp: IposHelpAddingCustomContentToIposComponent;
  @ViewChild(IposHelpDeviceComponent) devicecomp: IposHelpDeviceComponent;
  @ViewChild(IposHelpPartnerContentComponent) partnerContentcomp: IposHelpPartnerContentComponent;
  @ViewChild(IposHelpInstallingChromebookComponent) installChromebookComp: IposHelpInstallingChromebookComponent;
  @ViewChild(IposHelpIdleAssistantComponent) idleAssistantComp: IposHelpIdleAssistantComponent;
  @ViewChild(IposHelpUninstallingChromebookComponent) uninstallChromebookComp: IposHelpUninstallingChromebookComponent;
  @ViewChild(IposHelpUninstallationPackageComponent) uninstallcomp: IposHelpUninstallationPackageComponent;
  @ViewChild(IposHelpInstallationPackageComponent) installationPackageComp: IposHelpInstallationPackageComponent;
  @ViewChild(IposHelpSkuComponent) skuIdComp: IposHelpSkuComponent;

  userInfo: any;
  isAuthor: boolean;
  isOemPortalExapanded = true;
  ispartnerContentExpaned = false;
  showRetailGif = false;
  chromebookLabel = GlobalConstants.CHROME_OS;
  installingChromeText = GlobalConstants.INSTALLING_CHROMEBOOK_HELP_TITLE_TEXT;
  idleAssistantText = GlobalConstants.IDLE_ASSISTANT_HELP_TITLE_TEXT;
  private ngUnsubscribe = new Subject<boolean>();

  constructor(private appGlobal: AppGlobal, private cmnService: CommonService) { }
  
  ngOnInit(): void {
    this.appGlobal.$userAccount
      .subscribe((userData: User) => {
        // Make a copy of the user object
        this.userInfo = { ...userData };
        this.isAuthor = this.userInfo.role === GlobalConstants.AUTHOR ? true : false;
      });
    if(this.loginUserRole === 'regionalHQ'){
      this.sideNav= "regionalHQLogin";
    } else if(this.loginUserRole === 'deviceExecutive') {
      this.sideNav= "device";
    }
    else{
      this.sideNav = GlobalConstants.CREATE_USER_ACCOUNT;
    }
    
    this.cmnService.getRetailGifValue
    .pipe(takeUntil(this.ngUnsubscribe))
    .subscribe(data => {
      if(data) {
        this.showRetailGif = true;
        setTimeout(() => {
          this.showRetailGif = false; 
          this.cmnService.setRetailGifValue(false);
        }, 1000);
      }
    });
    this.chromeSideNav = GlobalConstants.SIDE_NAV_TEXT_INSTALL_CHROME;
  }

  sideNavScroll(data) {
    if (this.sideNav === 'assetLibrary') {
      this.assetScroll(data);
    } else if (this.sideNav === 'faq') {
      this.faqScroll(data);
    } else if (this.sideNav === 'createCustomInstallation') {
      this.createCustomScroll(data);
    } else if (this.sideNav === 'customContentToIpos') {
      this.addCustomScroll(data);
    } else if (this.sideNav === 'device') {
      this.deviceScroll(data);
    } else if (this.sideNav === 'oda') {
      this.odaScroll(data);
    } else if (this.sideNav === 'uninstallChromebook') {
      this.uninstallChromeScroll(data);
    } else if (this.sideNav === 'partnerContent') {
      this.partnerContentScroll(data);
    } else if (this.sideNav === 'uninstallPackage') {
      this.uninstallScroll(data);
    } else if (this.sideNav === 'installationProcess') {
      this.installScroll(data);
    }
    else if (this.sideNav === 'skuDataId') {
      this.skuDataScroll(data);
    }
  }

  deviceScroll(data) {
    this.devicecomp.change(data);
  }
  addCustomScroll(data) {
    this.addcomp.change(data);
  }
  assetScroll(data) {
    this.assetscomp.change(data);
  }
  faqScroll(data) {
    this.faqcomp.change(data);
  }
  odaScroll(data) {
    this.odacomp.change(data);
  }
  createCustomScroll(data) {
    this.installcomp.change(data);
  }
  partnerContentScroll(data) {
    this.partnerContentcomp.change(data);
  }
  uninstallChromeScroll(data) {
    this.uninstallChromebookComp.change(data);
  }
  uninstallScroll(data) {
    this.uninstallcomp.change(data);
  }
  installScroll(data) {
    this.installationPackageComp.change(data);
  }
  skuDataScroll(data) {
    this.skuIdComp.change(data);
  }
  chromebookScroll(data) {
    if (data === 'installChrome' || data === 'installChrome_sectionA' || data === 'installChrome_sectionC' || data === 'installChrome_sectionD') {
      this.chromeSideNav = GlobalConstants.SIDE_NAV_TEXT_INSTALL_CHROME;
      this.openChromeNav();
      if (this.installChromebookComp !== undefined) {
        this.installChromebookComp.change(data);
      }
    } else if (data === 'idleAssist' || data === 'idleAssist_sectionA' || data === 'idleAssist_sectionB') {
      this.chromeSideNav = GlobalConstants.SIDE_NAV_TEXT_IDLE_ASSISTANT_CHROME;
      this.openChromeNav();
      if (this.idleAssistantComp !== undefined) {
        this.idleAssistantComp.change(data);
      }
    } else {
      this.chromeSideNav = GlobalConstants.SIDE_NAV_TEXT_UNINSTALL_CHROME;
      this.openChromeNav();
      if (this.uninstallChromebookComp !== undefined) {
        this.uninstallChromebookComp.change(data);
      }
    }
  }

  openChromeNav() {
    this.setSideNav(this.chromeSideNav);
  }

  setSideNav(value) {
    this.sideNav = value;
    if (value === 'customContentToIpos') {
      this.iscustomContentToIposExpanded = !(this.iscustomContentToIposExpanded);
    } else if (value === 'oemPartnerPortal') {
      this.isOemPortalExapanded = !this.isOemPortalExapanded;
    } else if (value === 'assetLibrary') {
      this.isAssetLibraryExpanded = !(this.isAssetLibraryExpanded);
    }
    else if (value === 'device') {
      this.isDeviceExpanded = !(this.isDeviceExpanded);
    }
    else if (value === 'createCustomInstallation') {
      this.isCreateCustomInstallationExpanded = !this.isCreateCustomInstallationExpanded
    }
    else if (value === 'faq') {
      this.isFaqExpaned = !this.isFaqExpaned;
    }
    else if (value === 'oda') {
      this.isOdaExpaned = !this.isOdaExpaned;
    }
    else if (value === 'installChromebook' || value === 'uninstallChromebook' || value === 'idleAssistant') {
      this.isChromebookExpanded = !this.isChromebookExpanded;
    }
    else if (value === 'partnerContent') {
      this.ispartnerContentExpaned = !this.ispartnerContentExpaned;
    }
    else if (value === 'uninstallPackage') {
      this.isUninstallExpanded = !this.isUninstallExpanded;
    }
    else if (value === 'installationProcess') {
      this.isInstallationProcessExpanded = !this.isInstallationProcessExpanded;
    }
    else if (value === 'skuDataId') {
      this.isSkuExpanded = !this.isSkuExpanded;
    }
  }

  getSubMenu() {
    this.isExpanded = !this.isExpanded;
  }

  openComponent(data) {
    this.assetToHelp = data[2];
    this.sideNav = data[0];
    if (data[1] === 'device') {
      this.isDeviceExpanded = false;
    }
    if (data[0] === 'assetLibrary') {
      this.isAssetLibraryExpanded = true;
      this.isCreateCustomInstallationExpanded = false;
      this.iscustomContentToIposExpanded = false;
    }
    if (data[0] === 'installationProcess') {
      this.isCreateCustomInstallationExpanded = false;
      this.isFaqExpaned = false;
    }
    if (data[0] === 'createCustomInstallation') {
      this.isCreateCustomInstallationExpanded = true;

    }
    if (data[0] === 'customContentToIpos') {
      this.iscustomContentToIposExpanded = true;
      this.isAssetLibraryExpanded = false;
      this.isCreateCustomInstallationExpanded = false;
    }
    if (data[0] === 'manageInstallationProfile') {
      this.iscustomContentToIposExpanded = false;
      this.isAssetLibraryExpanded = false;
      this.isCreateCustomInstallationExpanded = false;
    }
  }

  partnerScrollTo(data) {
    if (data === 'enterModelSku') {
      this.partnercomp.enterSku.nativeElement.scrollIntoView();
    } else if (data === 'createPartner') {
      this.partnercomp.createPartner.nativeElement.scrollIntoView();
    } else if (data === 'attractloopVideo') {
      this.partnercomp.attractVideo.nativeElement.scrollIntoView();
    } else if (data === 'packaging') {
      this.partnercomp.packaging.nativeElement.scrollIntoView();
    } else if (data === 'partnerContent') {
      this.partnercomp.partnerContent.nativeElement.scrollIntoView();
    }
  }
}
